import { createApi } from '@reduxjs/toolkit/query/react';

import { CaseContext } from '../types/case-context-types';
import { baseQueryWithErrorHandling } from './baseQuery';

export const matterContextApi = createApi({
  reducerPath: 'matterContextApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['MatterContext'],
  endpoints: (builder) => ({
    getMatterContext: builder.query<CaseContext, { matterId: string }>({
      query: ({ matterId }) =>
        `api/matters/${matterId}/virtual-chats/context/get/`,
      providesTags: (result, error, { matterId }) => [
        { type: 'MatterContext', id: matterId },
      ],
    }),
    updateMatterContext: builder.mutation<
      CaseContext,
      { matterId: string; data: Partial<CaseContext> }
    >({
      query: ({ matterId, data }) => ({
        url: `api/matters/${matterId}/virtual-chats/context/update/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { matterId }) => [
        { type: 'MatterContext', id: matterId },
      ],
    }),
    generateContext: builder.mutation<CaseContext, { matterId: string }>({
      query: ({ matterId }) => ({
        url: `api/matters/${matterId}/virtual-chats/context/generate/`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { matterId }) => [
        { type: 'MatterContext', id: matterId },
      ],
    }),
  }),
});

export const {
  useGetMatterContextQuery,
  useUpdateMatterContextMutation,
  useGenerateContextMutation,
} = matterContextApi;
